let schedule = [
  {
    day: "LUNI",
    date: "07.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- Creativity & Creative Thinking\
        <br>- Career guidance'
      },
      {
        hourlyIntervals: '14:00 - 17:00',
        training: '- Job Interview'
      }
    ]
  },
  {
    day: "MARTI",
    date: "08.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- Time Management'
      },
      {
        hourlyIntervals: '14:00 - 17:00',
        training: '- Negotiation Skills\
        <br>- Self Understanding'
      }
    ]
  },
  {
    day: "MIERCURI",
    date: "09.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- How to learn efficiently\
        <br>- How to reach your full potential'
      },
      {
        hourlyIntervals: '14:00 - 17:00',
        training: '- Strategic Thinking'
      }
    ]
  },
  {
    day: "JOI",
    date: "10.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- Public Speaking'
      },
      {
        hourlyIntervals: '14:00 - 17:00',
        training: '- Assertion\
        <br>- Emotional Intelligence'
      }
    ]
  },
  {
    day: "VINERI",
    date: "11.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- Stress Management\
        <br>- Problem Solving'
      },
      {
        hourlyIntervals: '14:00 - 18:00',
        training: '- CaseStudy Work'
      }
    ]
  },
  {
    day: "SAMBATA",
    date: "12.09.2020",
    trainings: [
      {
        hourlyIntervals: '11:00 - 14:00',
        training: '- CaseStudy Work'
      },
      {
        hourlyIntervals: '15:00 - 19:00',
        training: '- CaseStudy Presentations'
      }
    ]
  },
  {
    day: "DUMINICA",
    date: "13.09.2020",
    trainings: [
      {
        hourlyIntervals: '10:00 - 13:00',
        training: '- Speeches'
      },
      {
        hourlyIntervals: '13:30 - 16:30',
        training: '- Speeches'
      },
      {
        hourlyIntervals: '17:00 - 20:00',
        training: '- Speeches'
      }
    ]
  }
]

export default schedule;